/* eslint-disable @typescript-eslint/no-non-null-assertion */
import CalendarIcon from '@mui/icons-material/CalendarMonth'
import { isPast } from 'date-fns/isPast'

import { ignoreTimezone, useDateFormatter } from '../../../../utils/date'
import { type Move, useSelectedQuote } from '../../../../modules/moves'
import TimeControl from '../TimeControl'
import { useGetQuoteDeliveryWindow, useGetQuoteJobDate, useGetQuoteJobLabel } from '../../../../modules/quotes'
import { useTranslation } from 'react-i18next'
import DateRanges from '../../../QuoteComponent/Jobs/DateRanges'

type DateRangesSectionProps = {
  move: Move
}

const DateRangesSection: React.FC<DateRangesSectionProps> = ({
  move,
}) => {
  const { t } = useTranslation()
  const formatDate = useDateFormatter()
  const selectedQuote = useSelectedQuote()
  const getQuoteJobLabel = useGetQuoteJobLabel()
  const getQuoteJobDate = useGetQuoteJobDate()
  const getQuoteDeliveryWindow = useGetQuoteDeliveryWindow()

  if (!selectedQuote?.jobs?.length) {
    return null
  }

  const quoteJobsWithDateRanges = selectedQuote.jobs.filter((jobQuote) => {
    return !!jobQuote.dateRange?.pickupWindowEndDate || !!jobQuote.dateRange?.deliveryWindowStartDate
  })

  if (!quoteJobsWithDateRanges.length) {
    return null
  }

  const nbJobs = move.jobs.length
  const multiJobs = nbJobs > 1

  return (
    <div className="mb-8 flex flex-col gap-y-4">
      { quoteJobsWithDateRanges.map(quoteJob => {
        const jobIndex = move.jobs.findIndex(job => job.id === quoteJob.jobId)
        if (jobIndex === -1) {
          return null
        }

        const pickup = getQuoteJobDate(quoteJob)
        const delivery = getQuoteDeliveryWindow(quoteJob)

        return (
          <div
            key={quoteJob.jobId}
          >
            { multiJobs && (
              <div className="px-4 pb-1 pt-3">
                <h2 className="font-body2 text-lg font-bold text-black">
                  { t('forms.checkout.dateRanges.day', { jobNumber: jobIndex + 1, nbJobs }) }
                </h2>
              </div>
            ) }
            <div className="flex rounded-xl border">

              { pickup && (
                <div className="flex-1 p-4">
                  <h2 className="mb-2 font-body2 text-sm text-neutral-500">
                    <div className="flex items-center gap-1">
                      <CalendarIcon className="!text-[20px] text-neutral-500" />
                      { t('quotes.quote.pickupWindow') }
                    </div>
                  </h2>
                  <div className="font-bold text-neutral-600">
                    { formatDate(pickup, { fromToClassName: 'font-normal text-neutral-400' }) }
                  </div>
                </div>
              ) }

              { delivery && (
                <div className="flex-1 p-4">
                  <h2 className="mb-2 font-body2 text-sm text-neutral-500">
                    <div className="flex items-center gap-1">
                      <CalendarIcon className="!text-[20px] text-neutral-500" />
                      { t('quotes.quote.deliveryWindow') }
                    </div>
                  </h2>
                  <div className="font-bold text-neutral-600">
                    { formatDate(delivery, { fromToClassName: 'font-normal text-neutral-400' }) }
                  </div>
                </div>
              ) }
            </div>
          </div>
        )
      }) }
    </div>
  )
}

export default DateRangesSection
